export function onDOMContentLoaded(callback: () => Promise<void>): void {
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', callback);
	} else {
		void callback();
	}
}
